import { render, staticRenderFns } from "./ZDMStreetLightsAdmin.vue?vue&type=template&id=00ca8838&scoped=true&"
import script from "./ZDMStreetLightsAdmin.vue?vue&type=script&lang=js&"
export * from "./ZDMStreetLightsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ca8838",
  null
  
)

export default component.exports